import apiClient from '../apiClient';

export const getUsers = () => {
  return apiClient.get('/users');
};

export const getUser = (id) => {
  return apiClient.get(`/users/${id}`);
};

export const createUser = (userData) => {
  return apiClient.post('/users', userData);
};

export const updateUser = (id, userData) => {
  return apiClient.put(`/users/${id}`, userData);
};

export const deleteUser = (id) => {
  return apiClient.delete(`/users/${id}`);
};

export const getUserPermissionsList = (userId) => {
  return apiClient.get(`/users/${userId}/permissions`);
};

export const assignPermissionToUser = (userId, permissionId) => {
  return apiClient.post(`/users/${userId}/permissions/${permissionId}`);
};

export const removePermissionFromUser = (userId, permissionId) => {
  return apiClient.delete(`/users/${userId}/permissions/${permissionId}`);
};

export const getUserRoles = (userId) => {
  return apiClient.get(`/users/${userId}/roles`);
};

export const assignRoleToUser = (userId, roleId) => {
  return apiClient.post(`/users/${userId}/roles/${roleId}`);
};

export const removeRoleFromUser = (userId, roleId) => {
  return apiClient.delete(`/users/${userId}/roles/${roleId}`);
};

export const updateProfile = (profileData) => {
  return apiClient.put('/users/profile', profileData);
};


export const resendWelcomeEmail = (userId) => {
  return apiClient.post(`/users/${userId}/resend-welcome-email`);
};

export const updateUserPermissions = (userId, permissionIds) => {
  return apiClient.put(`/users/${userId}/permissions`, permissionIds);
};

export const disableUser = (id) => {
  return apiClient.post(`/users/${id}/disable`);
};

export const enableUser = (id) => {
  return apiClient.post(`/users/${id}/enable`);
};